import "./ProfileSetupScreen.css";
import { useEffect, useState } from "react";
import letsDoItIcon from "../../assets/images/lets-do-it-icon.svg";
import tickIcon from "../../assets/images/profile-setup-tick.svg";
import selectedTickIcon from "../../assets/images/profile-setup-selected-tick.svg";
import { useMutation } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import { CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";
import "react-phone-input-2/lib/style.css";
import { useStorage } from "services/StorageProvider";
import { WEB_LINK } from "utils/strings";
import { trackSignUp } from "utils/analytics";

const ProfileSetupSecondScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const firstName = location.state?.firstName;
  const lastName = location.state?.lastName;
  const mobileNumber = location.state?.mobileNumber;
  const { updateUserProfile } = useWSMApi();
  const { updateUserProfileData } = useStorage();
  const [termsAccepted, setTermsAccepted] = useState(() => {
    return JSON.parse(sessionStorage.getItem("termsAccepted") || "false");
  });
  const [isFounder, setIsFounder] = useState(() => {
    const value = sessionStorage.getItem("isFounder");
    return value !== null ? JSON.parse(value) : null;
  });
  const [profileLink, setProfileLink] = useState(() => {
    const storedProfileLink = sessionStorage.getItem("profileLink");

    // If profileLink was already stored, always use it
    if (storedProfileLink !== null) {
      return storedProfileLink;
    }

    // Only use leadData during the initial setup
    const storedLeadData = sessionStorage.getItem("customerLeadData");

    if (storedLeadData) {
      try {
        const leadData = JSON.parse(storedLeadData);
        return leadData.profile_link || "";
      } catch (error) {
        console.error("Failed to parse customerLeadData:", error);
      }
    }

    return "";
  });
  const isDisabled =
    isFounder === null || !profileLink.trim() || !termsAccepted;

  useEffect(() => {
    sessionStorage.setItem("profileLink", profileLink);
  }, [profileLink]);

  useEffect(() => {
    sessionStorage.setItem("isFounder", JSON.stringify(isFounder));
  }, [isFounder]);

  useEffect(() => {
    sessionStorage.setItem("termsAccepted", JSON.stringify(termsAccepted));
  }, [termsAccepted]);

  const updateUserMutation = useMutation({
    mutationFn: () =>
      updateUserProfile({
        first_name: firstName,
        last_name: lastName,
        mobile_number: "+" + mobileNumber,
        profile_link: profileLink,
        is_founder: isFounder,
      }),
    onSuccess: (response) => {
      sessionStorage.removeItem("profileLink");
      sessionStorage.removeItem("isFounder");
      sessionStorage.removeItem("termsAccepted");

      updateUserProfileData(response);
      trackSignUp();
      navigate(ROUTE_PATHS.WSM_HOME, { replace: true });
      // isFounder
      //   ? navigate(ROUTE_PATHS.WSM_PROFILE_SETUP_FOUNDER, {
      //     replace: true,
      //   })
      //   : navigate(ROUTE_PATHS.WSM_PROFILE_SETUP_NOT_FOUNDER, {
      //     replace: true,
      //   });
    },
  });

  const handleContinueClick = () => {
    updateUserMutation.mutate();
  };

  return (
    <div className="wms-mobile-container">
      <div className="profile-setup-screen-container">
        <header className="profile-setup-screen-header-header-bar">
          Enter the Realm
        </header>
        <div className="profile-setup-screen-top-container">
          <div className="text-container">
            <span>
              A 3<sup className="sub-text">rd </sup> Space
            </span>
            <span style={{ color: "#ff6b35" }}> Ecosystem</span>
          </div>
        </div>
        <div className="profile-setup-screen-banner-container">
          <div className="second-text">
            Where{" "}
            <span style={{ color: "#FF6B35" }}>
              High Performance and Human Wellbeing coexist by Design.{" "}
            </span>
          </div>
          <div className="divider"></div>
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Ur <span className="sub-text">Professional Profile</span>
            <span className="required">*</span>
          </span>
          <input
            placeholder="🔗 Enter Website/Linkedin/Instagram Link"
            value={profileLink}
            onChange={(e) => setProfileLink(e.target.value)}
          />
        </div>
        <div className="profile-setup-screen-item-container">
          <span>
            Are you a <span className="sub-text">founder/owner ?</span>
            <span className="required">*</span>
          </span>
          <div className="button-container">
            <button
              className={isFounder === true ? "selected" : ""}
              onClick={() => setIsFounder(true)}
            >
              Yes
            </button>

            <button
              className={isFounder === false ? "selected" : ""}
              onClick={() => setIsFounder(false)}
            >
              No
            </button>
          </div>
        </div>

        <div
          className="profile-setup-screen-footer-container"
          onClick={() => setTermsAccepted(!termsAccepted)}
        >
          <img
            src={termsAccepted ? selectedTickIcon : tickIcon}
            alt="info-logo"
          />
          <span>
            By Stepping in, you agree to the{" "}
            <span
              className="terms-link"
              onClick={(e) => {
                e.stopPropagation();
                navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
                  state: {
                    anyData: {
                      title: "Terms & Conditions",
                      url: WEB_LINK.TERM_CONDITION,
                    },
                  },
                });
              }}
            >
              Terms & Conditions
            </span>
            .
          </span>
        </div>
        <button
          onClick={handleContinueClick}
          disabled={isDisabled || updateUserMutation.isPending}
        >
          {updateUserMutation?.isPending ? (
            <CircularProgress size={30} color="inherit" />
          ) : (
            <>
              Step into the Ecosystem
              <img src={letsDoItIcon} alt="lets-do-it-logo" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProfileSetupSecondScreen;
